export enum RackPositionStatusEnum {
    OCCUPIED = 'occupied',
    PARTIALLYOCCUPIED = 'partially occupied',
    NOTOCCUPIED = 'not occupied',
  
}